module.exports = __webpack_public_path__ + "static/media/zh-TW.e2d2694a.svg";